import { useSession } from 'next-auth/react';
import { hasEditorRights } from '@/app/lib/auth/roles';

const useEditorRights = () => {
    const { data: session, status: sessionStatus } = useSession();

    if (sessionStatus !== 'authenticated') return false;
    return hasEditorRights(session?.user?.roles);
};

export default useEditorRights;
